export default __webpack_public_path__ + "static/media/wireframeConcept.d50cfceb.webp";